var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23047 3.99214C1.23047 3.55422 1.56346 3.19922 1.97422 3.19922H13.2367C13.6475 3.19922 13.9805 3.55422 13.9805 3.99214C13.9805 4.43006 13.6475 4.78506 13.2367 4.78506V14.9797C13.2367 15.5428 12.8086 15.9992 12.2805 15.9992H2.93047C2.40235 15.9992 1.97422 15.5428 1.97422 14.9797V4.78506C1.56346 4.78506 1.23047 4.43006 1.23047 3.99214ZM3.46172 4.78506V14.4134H11.7492V4.78506H3.46172Z",
    fill: "#D4D4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05556 2.40078V3.20078H4.5V1.82935C4.5 1.26129 4.94772 0.800781 5.5 0.800781H9.5C10.0523 0.800781 10.5 1.26129 10.5 1.82935V3.20078H8.94444V2.40078H6.05556Z",
    fill: "#D4D4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21094 6.39844C6.62515 6.39844 6.96094 6.72195 6.96094 7.12102V12.0759C6.96094 12.4749 6.62515 12.7984 6.21094 12.7984C5.79672 12.7984 5.46094 12.4749 5.46094 12.0759V7.12102C5.46094 6.72195 5.79672 6.39844 6.21094 6.39844Z",
    fill: "#D4D4D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21094 6.39844C9.62515 6.39844 9.96094 6.72195 9.96094 7.12102V12.0759C9.96094 12.4749 9.62515 12.7984 9.21094 12.7984C8.79672 12.7984 8.46094 12.4749 8.46094 12.0759V7.12102C8.46094 6.72195 8.79672 6.39844 9.21094 6.39844Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.2b55440eca4dfe1c95c798b8d61bd4c7.svg";
export { ForwardRef as ReactComponent };